export const requiredField = {
  required: 'error.required',
} as const;

export const requiredUnregisterField = {
  required: 'error.required',
  shouldUnregister: true,
} as const;
